<template>
  <div>
    <Loader :messageSelector="messageSelector" :overlay="overlay" />

    <v-form ref="form" v-model="valid" :disabled="readonly">
      <div v-if="showBlockCentral">
        <RessourceInfoBulle code="APRP-FO-1" />

        <fieldset>
          <legend class="text-h6 text-sm-h5">Formation universitaire à l'appui de la demande</legend>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left" style="width: 50%">Diplôme(s)</th>
                  <th>Date obtention</th>
                  <th>Date fin (ou prévue) du programme</th>
                  <th class="text-right">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in getFormations" :key="index">
                  <td>
                    <v-autocomplete
                      v-model="item.formationUniversitaireEnTravailSocial"
                      :item-text="itemText"
                      :item-value="itemValue"
                      :items="listeFormations"
                      :readonly="true"
                      :rules="rules.TypeFormations"
                      :disabled="true"
                      label="Diplôme"
                      required
                      return-object
                    ></v-autocomplete>
                    <div
                      v-if="item.formationUniversitaireEnTravailSocial && typeAutre.find((t) => t === item.formationUniversitaireEnTravailSocial.id)"
                    >
                      <v-text-field
                        v-model="item.autreFormation"
                        :rules="rules.AutreFormation"
                        :readonly="item.id != null"
                        class="cssRequired"
                        label="Si autre, précisez diplôme, domaine, université et pays"
                        required
                      ></v-text-field>
                    </div>
                  </td>
                  <td>
                    <v-menu
                      :key="index"
                      ref="menuDateObtention"
                      v-model="menuDateObtention[index]"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      eager
                      min-width="290px"
                      offset-y
                      required
                      transition="scale-transition"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-sheet style="background-color: transparent">
                          <v-text-field
                            :key="index"
                            :disabled="item.id != null"
                            v-model="item.dateObtention"
                            :rules="[
                              (item.dateDeFinDeProgramme && item.dateDeFinDeProgramme.length > 0) ||
                                (item.dateObtention && item.dateObtention.length > 0) ||
                                'Au moins une des deux date est requise',
                            ]"
                            append-icon="mdi-calendar"
                            hint="YYYY-MM-DD format"
                            label="Date obtention du diplôme "
                            readonly
                            required
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </v-sheet>
                      </template>
                      <v-date-picker
                        v-if="item.id == null"
                        :key="index"
                        ref="pickerStart"
                        v-model="item.dateObtention"
                        :max="new Date().toISOString().substring(0, 10)"
                        :readonly="item.demandeAdmission !== demandeAdmissionId"
                        @change="saveStart(item.dateObtention, index)"
                      ></v-date-picker>
                    </v-menu>
                  </td>
                  <td>
                    <v-menu
                      :key="index"
                      ref="menuDateDeFinDeProgramme"
                      v-model="menuDateDeFinDeProgramme[index]"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :readonly="item.demandeAdmission !== demandeAdmissionId"
                      eager
                      min-width="290px"
                      offset-y
                      required
                      transition="scale-transition"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-sheet style="background-color: transparent">
                          <v-text-field
                            :key="index"
                            :disabled="item.id != null"
                            v-model="item.dateDeFinDeProgramme"
                            :rules="[
                              (item.dateDeFinDeProgramme && item.dateDeFinDeProgramme.length > 0) ||
                                (item.dateObtention && item.dateObtention.length > 0) ||
                                'Au moins une des deux date est requise',
                            ]"
                            append-icon="mdi-calendar"
                            autocomplete="off"
                            hint="Format YYYY-MM-DD"
                            label="Date fin si nouveau finissant(e)"
                            readonly
                            required
                            v-bind="attrs"
                            @change="validateForm"
                            v-on="on"
                          ></v-text-field>
                        </v-sheet>
                      </template>
                      <v-date-picker
                        v-if="item.id == null"
                        :key="index"
                        ref="pickerEnd"
                        v-model="item.dateDeFinDeProgramme"
                        :readonly="item.demandeAdmission !== demandeAdmissionId"
                        required
                        @change="saveEnd(item.dateDeFinDeProgramme, index)"
                      ></v-date-picker>
                    </v-menu>
                  </td>
                  <td class="text-right">
                    <v-icon v-if="item.id == null"
                      v-bind:class="{
                        'clickable redIcon':
                          item.demandeAdmission === demandeAdmissionId,
                        'standardPointer greyIcon':
                          item.demandeAdmission !== demandeAdmissionId,
                      }"
                      @click="deleteRow(item)"
                      >mdi-delete
                    </v-icon>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <div class="text-center mt-6 d-flex justify-lg-flex-end">
            <v-btn color="primary" @click="ajouter()">ajouter</v-btn>
          </div>
          <template v-if="showConfirmationCheckbox">
            <v-checkbox class="mt-6" color="primary" required hide-details="auto" v-model="confirmationVisionnage">
              <template v-slot:label> Je confirme les éléments ci-dessous : <span class="required-star">*</span> </template>
            </v-checkbox>
            <div>
              <RessourceInfoBulle code="APRP-FO-3" />
            </div>
          </template>
        </fieldset>

        <RessourceInfoBulle code="APRP-FO-2" />

        <div>
          <!-- Si pas autorisation special -->
          <fieldset v-if="!hasAutorisationSpecial">
            <legend class="text-h6 text-sm-h5">Diplômes et relevés de notes</legend>

            <v-row>
              <v-col class="legalSection" cols="12" md="6">
                  <Attachment
                    ref="equivDiplome"
                    file-prefix="form_equiv_diplome"
                    @completeEvent="saveNextAttachment"
                    @refreshEvent="validateForm(true)"
                  ></Attachment>
                </v-col>
                <v-col class="legalSection" cols="12" md="6">
                  <Attachment
                    ref="equivNotes"
                    file-prefix="form_equiv_notes"
                    @completeEvent="saveNextAttachment"
                    @refreshEvent="validateForm(true)"
                  ></Attachment>
              </v-col>
            </v-row>
          </fieldset>

          <!-- Si autorisation special -->
          <fieldset v-if="hasAutorisationSpecial">
            <legend class="text-h6 text-sm-h5">Preuve d'autorisation d'exercice et employeur</legend>
            <Attachment
              ref="employeurAttachment"
              file-prefix="form_employeur"
              @completeEvent="saveNextAttachment"
              @refreshEvent="validateForm(true)"
            ></Attachment>
            <div style="margin-top: 32px">
              <span class="font-italic">Téléverser la preuve de l'employeur (établissement, université ou organisme) incluant :</span>
              <ol>
                <li>Nom de l'employeur où vous serez amené à exercer des activités réservées au Québec</li>
                <li>Motif de la demande</li>
                <li>Dates prévues du début des activités au Québec</li>
                <li>Durée de l'autorisation recherchée</li>
                <li>Identification de la clientèle pour qui le candidat exercera : personne, couple, famille, groupe ou collectivité</li>
                <li>
                  Organisme ou institution où le candidat exercera ou indication, le cas échéant, que le candidat exercera en télépratique à partir de
                  la province, de l'état ou du pays où il est légalement autorisé à exercer la profession
                </li>
                <li>Fréquence et nature des activités professionnelles prévues</li>
                <li>Attestation d'assurance de responsabilité professionnelle garantissant que les services professionnels sont assurés.</li>
              </ol>
              <Attachment
                ref="preuveAttachment"
                file-prefix="form_preuve"
                :hide-title="true"
                :hide-description="true"
                @completeEvent="saveNextAttachment"
                @refreshEvent="validateForm(true)"
              ></Attachment>
            </div>
          </fieldset>
        </div>
      </div>
    </v-form>

    <div class="text-center mt-6 d-flex justify-space-between">
      <v-btn color="primary" @click="back()">Retour</v-btn>
      <v-btn :disabled="!canSubmit || !valid || !this.getAllFormations" color="secondary" @click="saveAndContinueLater()"
        >Enregistrer et terminer plus tard
      </v-btn>
      <v-btn :disabled="!canSubmit || !valid || !this.getAllFormations" color="primary" @click="saveAndContinue()"> Suivant </v-btn>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import Attachment from "../attachments/Attachment";
import Loader from "../Loader";
import NavigationPageFormulaireMixin from "@/mixins/navigationPageFormulaireMixin";
import PageReadonlyFormulaireAdmissionMixin from "@/mixins/pageReadonlyFormulaireAdmissionMixin";
import AttachementFormulaireMixin from "@/mixins/attachementFormulaireMixin";

export default {
  mixins: [NavigationPageFormulaireMixin, PageReadonlyFormulaireAdmissionMixin, AttachementFormulaireMixin],
  props: {
    routeName: {
      type: String,
      default: "",
    },
  },
  components: {
    Attachment: Attachment,
    Loader: Loader,
  },
  data() {
    return {
      overlay: false,
      messageSelector: "",
      valid: true,
      confirmationVisionnage: false,
      rules: {
        TypeFormations: [(v) => (!!v && v.length !== 0) || "Le diplôme est requis"],
        AutreFormation: [(v) => (!!v && v.length !== 0) || "La description de la formation est obligatoire"],
      },
      menuDateObtention: [],
      menuDateDeFinDeProgramme: [],
      typeAutre: [
        this.$catalogues.formationDiplome.AutreAutorisationSpeciale,
        this.$catalogues.formationDiplome.AutreDemandeEquivalenceDiplomeHorsQuebec,
        this.$catalogues.formationDiplome.AutreMembreInstanceReglementaireTravailSocialCanada,
        this.$catalogues.formationDiplome.Autre,
        this.$catalogues.formationDiplome.AutrePersonneAutoriseeActiviteReservee,
      ],
      dateMenu: false,
    };
  },
  computed: {
    ...mapGetters({
      demandeAdmissionId: "DemandeAdmission/GET_DEMANDEADMISSIONID",
      demandeAdmissionPpId: "DemandeAdmission/GET_CONTACTID",
      listeFormations: "Catalogue/GET_CATEGORIEFORMATION",
      getFormations: "FormationInitiale/GET_FORMATIONS",
      getAllFormations: "FormationInitiale/GET_ALL_FORMATIONS",
      getAutorisation: "AutorisationDePratique/GET_AUTORISATIONSDEPRATIQUE",
    }),
    hasAutorisationSpecial: function () {
      return (
        this.getAutorisation &&
        this.getAutorisation.some((t) => t.categorieAutorisation.id === this.$catalogues.categorieAutorisation.autorisationSpeciale)
      );
    },
    hasAutorisationTS: function () {
      return (
        this.getAutorisation &&
        this.getAutorisation.some((t) => t.categorieAutorisation.id == this.$catalogues.categorieAutorisation.travailleurSocial)
      );
    },
    preuveLinguistique: function () {
      return (
        this.getFormations &&
        this.getFormations.find(
          (t) => t.formationUniversitaireEnTravailSocial.code.includes("L") || t.formationUniversitaireEnTravailSocial.code === "TS/TCF"
        )
      );
    },
    showConfirmationCheckbox() {
      return (
        this.hasAutorisationTS &&
        this.getFormations?.some((formation) => {
          const formationId = formation.formationUniversitaireEnTravailSocial?.id;
          return (
            formationId === this.$catalogues.formationDiplome.AutreDemandeEquivalenceQuebec ||
            formationId === this.$catalogues.formationDiplome.AutreDemandeEquivalenceDiplomeHorsQuebec
          );
        })
      );
    },
    canSubmit: function () {
      let result = true;

      if (this.showConfirmationCheckbox && !this.confirmationVisionnage) {
        result = false;
      }

      // Si j'ai une autorisation spéciale et que je n'ai pas de formation de type autorisation spéciale ou
      // que j'ai une autorisation spéciale et que je n'ai pas upload de justificatif
      if (
        this.hasAutorisationSpecial &&
        !this.getFormations.some(
          (f) => f.formationUniversitaireEnTravailSocial.id === process.env.VUE_APP_FORMATION_DIPLOME_AUTREAUTORISATIONSPECIALE
        )
      ) {
        result = false;
      }

      if (this.getFormations.length === 0 && this.showBlockCentral) {
        result = false;
      }
      return result;
    },
    showBlockCentral() {
      return !this.getAutorisation.some((a) => a.demandeAdmission === this.demandeAdmissionId && a.dateDeFin != null);
    },
  },
  async created() {
    await this.fetchItems();
  },
  watch: {
    menuDateObtention(val) {
      let self = this;
      val.forEach((picker, index) => {
        if (picker) {
          picker && setTimeout(() => (self.$refs.pickerStart[index].activePicker = "YEAR"));
        }
      });
    },
    menuDateDeFinDeProgramme(val) {
      let self = this;
      val.forEach((picker, index) => {
        if (picker) {
          picker && setTimeout(() => (self.$refs.pickerEnd[index].activePicker = "YEAR"));
        }
      });
    },
    getFormations: {
      handler(newFormations) {
        this.confirmationVisionnage = newFormations?.some((f) => f.confirmationVisionnageInfos === true) || false;
      },
      immediate: true,
    },
  },
  methods: {
    ...mapMutations({
      setFormations: "FormationInitiale/SET_FORMATIONS",
      addFormation: "FormationInitiale/ADD_FORMATION",
      removeFormation: "FormationInitiale/REMOVE_FORMATION",
      setDateObtention: "FormationInitiale/SET_DATEOBTENTION",
      setDateDeFinDeProgramme: "FormationInitiale/SET_DATEDEFINDEPROGRAMME",
    }),
    ...mapActions({
      getCatalogue: "Catalogue/getCatalogue",
      getFormationInitialeByContactId: "FormationInitiale/getFormationInitialeByContactId",
      deleteFormationInitiale: "FormationInitiale/deleteFormationInitiale",
      createFormationInitiale: "FormationInitiale/createFormationInitiale",
      updateFormationInitiale: "FormationInitiale/updateFormationInitiale",
      getDocumentsByContactId: "Documents/getDocumentsByContactId",
      getAutorisationDePratiqueByContactId: "AutorisationDePratique/getAutorisationDePratiqueByContactId",
    }),
    async fetchItems() {
      try {
        this.messageSelector = "Loading";
        this.overlay = true;

        // Catalogue Categorie Formation
        await this.getCatalogue(1526);

        if (this.demandeAdmissionPpId) {
          await this.getFormationInitialeByContactId(this.demandeAdmissionPpId);
          await this.getDocumentsByContactId(this.demandeAdmissionPpId);
          if (!this.getAutorisation || this.getAutorisation.length === 0) {
            await this.getAutorisationDePratiqueByContactId(this.demandeAdmissionPpId);
          }
        }

        if (this.hasAutorisationSpecial) {
          if (
            !this.getFormations ||
            !this.getFormations.find(
              (f) => f.formationUniversitaireEnTravailSocial.id === process.env.VUE_APP_FORMATION_DIPLOME_AUTREAUTORISATIONSPECIALE
            )
          ) {
            this.addFormation({
              id: null,
              contact: this.demandeAdmissionPpId,
              demandeAdmission: this.demandeAdmissionId,
              formationUniversitaireEnTravailSocial: this.listeFormations.find(
                (f) => f.id === process.env.VUE_APP_FORMATION_DIPLOME_AUTREAUTORISATIONSPECIALE
              ),
              dateObtention: null,
              dateDeFinDeProgramme: null,
              autreFormation: null,
              deleted: false,
            });
          }
        }

        // Liste les uploads de fichiers
        this.refsUpload = [
          () => this.$refs.linguistAttachment,
          () => this.$refs.equivTraduction,
          () => this.$refs.equivEval,
          () => this.$refs.equivDiplome,
          () => this.$refs.equivNotes,
          () => this.$refs.equivDescription,
          () => this.$refs.equivPlanCours,
          () => this.$refs.equivAttestationStage,
          () => this.$refs.equivCurriculum,
          () => this.$refs.equivAttestationEmployeur,
          () => this.$refs.equivAttestationBenevole,
          () => this.$refs.univAttachment,
          () => this.$refs.expAttachment,
          () => this.$refs.employeurAttachment,
          () => this.$refs.preuveAttachment,
        ];

        this.overlay = false;
      } catch (erreur) {
        console.log(erreur);
      }
    },
    save() {
      this.messageSelector = "Save";
      this.overlay = true;

      this.$refs.form.validate();
      if (this.valid && this.getAllFormations && this.canSubmit) {
        this.getAllFormations.forEach((element, index, array) => {
          if (element.formationUniversitaireEnTravailSocial && !this.typeAutre.find((t) => t === element.formationUniversitaireEnTravailSocial.id)) {
            element.autreFormation = "";
          }

          // Mise à jour de confirmationVisionnageInfos si la checkbox est affichée
          if (this.showConfirmationCheckbox) {
            element.confirmationVisionnageInfos = this.confirmationVisionnage;
          }

          if (element.id == null) {
            if (this.demandeAdmissionId) {
              element.demandeAdmission = this.demandeAdmissionId;
            }
            this.createFormationInitiale({ formation: element, index: index });
          } else {
            if (this.demandeAdmissionId) {
              element.demandeAdmission = this.demandeAdmissionId;
            }
            if (element.deleted === true) {
              this.deleteFormationInitiale(element.id);
            } else {
              this.updateFormationInitiale(element);
            }
          }
        });

        this.saveAttachments("demandeAdmission", this.demandeAdmissionId, () => {
          this.overlay = false;
          this.redirect();
        });
      }
    },
    ajouter() {
      if (this.listeFormations && this.listeFormations[0]) {
        this.addFormation({
          id: null,
          pp: this.demandeAdmissionPpId,
          demandeAdmission: this.demandeAdmissionId,
          formationUniversitaireEnTravailSocial: this.listeFormations.find(
            (f) => f.id == this.$catalogues.formationDiplome.AutrePersonneAutoriseeActiviteReservee
          ),
        });
      }
    },
    deleteRow(item) {
      if (item.demandeAdmission == this.demandeAdmissionId) {
        this.removeFormation(item);
      }
    },
    itemText: (item) => item.lang00,
    itemValue: (item) => item.id,
    validateForm(resetValidation = false) {
      this.valid = (this.$refs.form?.validate() || false) && this.canSubmit; // todo: convert/remove

      if (resetValidation) {
        this.$refs.form?.resetValidation();
      }
    },
    saveStart(date, index) {
      this.$refs.menuDateObtention[index].save(date);
    },
    saveEnd(date, index) {
      this.$refs.menuDateDeFinDeProgramme[index].save(date);
    },
  },
};
</script>

<style></style>
